exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidenav-container {\n  width: 100%;\n  height: 500px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9172/wa9172.component.css
// module id = ../../../../../src/app/pages/wa9Master/wa9172/wa9172.component.css
// module chunks = main